/**
 * What every Core request says about the build: its platform, as since the first build, and
 * echo's release (`AppConfig.appVersion`), so Core can ask an old build to update (platform
 * docs/architecture/multi-region/implementation/clients.md 1.8).
 *
 * `x-echo-version`, not the OE app's `x-oe-app-version`: Core holds that one to the OE app's
 * minimum (`MINIMUM_API_VERSION`, 2.0.0 when unset), which every echo release is below, and its
 * GraphQL would refuse echo's photos and shares outright. Core can tell an echo build older
 * than this one by `x-echo-platform` without `x-echo-version`.
 */
export function clientHeaders(
  platform: string,
  appVersion: string | undefined,
): Record<string, string> {
  return {
    'x-echo-platform': platform,
    ...(appVersion ? { 'x-echo-version': appVersion } : {}),
  };
}
